import axios from 'common/requester';
import { API } from 'common/constants/api-urls';

export const getMetricsTotals = async () => {
  const response = await axios.get(
    `${API.CUSTOM_METRICS}?include_gitstream=false`
  );
  return response.total;
};

export const getMetrics = async (limit = 20) => {
  return await axios.get(
    `${API.CUSTOM_METRICS}?include_gitstream=false&limit=${limit}`
  );
};
